import axios from "axios";
import { decryptData } from "../helpers/CryptoFun";

// const REACT_APP_MAIN_URL = `http://127.0.0.1:8000/api`
// const REACT_APP_MAIN_URL = `https://g-smart-backend.test/api`
const REACT_APP_MAIN_URL = `https://gsmart-ip.ch/backoffice/public/api`

// Auth
export const userLogin = async (data) => {
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/user-login`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};
export const adminLogin = async () => {
    const data = {
        'email': 'B.tasli@gsmart-ip.ch',
        'password': 'Gsm@rt2021'
    }
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/admin-login`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};

// Info
export const UserInfo = async () => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    if(user){
        const data = {
            'user_id': user?.id,
            'user_password': user?.password
        }

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/user-info`,
                data
            );
            if (res.data.status === true) {
                return res.data?.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};
export const subCompanies = async (company) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        const data = {
            'admin_id': user?.adminId,
            'admin_password': user?.adminPassword,
            'company': company,
            'lang': lang
        }

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/sub-companies`,
                data
            );
            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};
export const subCompaniesInfo = async (data) => {
    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    data['lang'] = lang

    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/sub-companies-info`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};

// Content
export const tasksPagination = async (data) => {
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/tasks-pagination`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};
export const filterContent = async (data) => {
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/filter-content`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};
export const getTasks = async (data) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        data['lang'] = lang
        data['admin_id'] = user?.adminId
        data['admin_password'] = user?.adminPassword

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/tasks`,
                data
            );

            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};
export const getMapTasks = async (data) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)
    
    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        data['admin_id'] = user?.adminId
        data['admin_password'] = user?.adminPassword
        data['lang'] = lang

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/tasks-map`,
                data
            );

            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};
export const classes = async (data) => {
    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    data['lang'] = lang
    
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/classes`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};

// Send mail
export const sendMil = async (data) => {
    try {
        const res = await axios.post(
            `${REACT_APP_MAIN_URL}/send-mail`,
            data
        );
        if (res.data.status === true) {
            return res.data;
        }
    } catch (error) {
        throw new Error(error);
    }
};

// Export pdf
export const exportPdf = async (data) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        data['lang'] = lang
        data['admin_id'] = user?.adminId
        data['admin_password'] = user?.adminPassword

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/export-excel`,
                data
            );
            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};


// Tasks v2
export const getTasksV3 = async (data) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        data['lang'] = lang
        data['admin_id'] = user?.adminId
        data['admin_password'] = user?.adminPassword

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/tasks-v3`,
                data
            );

            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            throw new Error(error);
        }
    }
};

// Export pdf
export const exportPdfV3 = async (data) => {
    let user = localStorage.getItem('gsmart-ip-user')
    user = decryptData(user)

    let lang = localStorage.getItem('gsmart-lang')
    if(!lang) lang = 'fr'

    if(user){
        data['lang'] = lang
        data['admin_id'] = user?.adminId
        data['admin_password'] = user?.adminPassword

        try {
            const res = await axios.post(
                `${REACT_APP_MAIN_URL}/export-excel-v3`,
                data
            );
            if (res.data.status === true) {
                return res.data;
            }
        } catch (error) {
            let message = 'server_not_responding_pdf';
            throw new Error(message);
        }
    }
};